export enum ArticleAccess {
    /** Access wasn't evaluated. */
    Unknown = 0,

    /** User has no access to the article at all. */
    Denied = 1,

    /** User can read full article. */
    Granted = 2,

    /** User can read a part of the article, but need to confirm reading the full article (snippet without lock). */
    ConfirmationRequired = 3,

    /** User can read a part of the article, but have to purchase subscription/issue/bundle in order to read the article (snippet with lock). */
    PurchaseRequired = 4,
}
